import { Grid } from '@mui/material'
import { useSideEffect } from '@src/data/store/effects/side-effects'
import { getApiClient } from '@src/services/api-client'
import { reportErrorToConsole } from '@src/services/error-logger'
import { useEffect, useState, type JSX } from 'react'
import { useParams } from 'react-router-dom'
import apis from '../../data/api'
import { useAppSelector } from '../../data/store'
import { creditSelectors } from '../../data/store/CreditApplication'
import { messageEffects, messageSelectors } from '../../data/store/Message'
import { CreditApplicationMessage, Merchant } from '../../data/types'
import MessageHeader from './components/MessageHeader'
import MessageList from './components/MessageList'

const apiClient = getApiClient()

const CreditApplicationMessagePage = (): JSX.Element | null => {
  const { id } = useParams()

  const dispatchEffect = useSideEffect()

  const [merchant, setMerchant] = useState<Merchant | null>(null)
  const currentApplication = useAppSelector(creditSelectors.getCurrent)
  const messages = useAppSelector(messageSelectors.getMessageList)

  useEffect(() => {
    if (currentApplication) {
      document.title = `${currentApplication.applicant.firstName} ${currentApplication.applicant.lastName}`
    }
  }, [currentApplication])

  useEffect(() => {
    if (currentApplication?.merchantId && apiClient) {
      apis.config
        .getMerchantById(apiClient, { id: currentApplication.merchantId })
        .then(setMerchant)
        .catch(reportErrorToConsole)
    }
  }, [currentApplication?.merchantId])

  const onSave = (data: Partial<CreditApplicationMessage>) => {
    data.creditApplicationId = id
    data.financingProgramId = currentApplication?.financingProgramId
    return dispatchEffect(messageEffects.createMessage(data))
  }
  return (
    <div style={{ marginBottom: 25 }}>
      <Grid container spacing={2} alignItems="center" size={12}>
        {currentApplication && merchant && (
          <MessageHeader merchant={merchant} currentApplication={currentApplication} />
        )}
        <Grid size={12}>
          <MessageList messages={messages} onSave={onSave} />
        </Grid>
      </Grid>
    </div>
  )
}

export default CreditApplicationMessagePage
